if (!customElements.get('evolved-device-guide')) {
  customElements.define('evolved-device-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      document.addEventListener('click', event => this.followUseCaseLink(event), {capture: true, signal: this.controller.signal});
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[data-device-panel]')];
      if (!this.tabs.length) return;
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index), {signal: this.controller.signal});
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); this.select(next); this.tabs[next].focus(); }
        }, {signal: this.controller.signal});
      });
      const requested = new URLSearchParams(location.search).get('device');
      const found = this.tabs.findIndex(tab => tab.dataset.device === requested);
      this.select(found >= 0 ? found : 0);
      this.setAttribute('data-ready', '');
    }
    select(index) {
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        this.panels[i].hidden = i !== index;
      });
      const action = this.querySelector('.ev-guide__actions>.ev-guide__all');
      const destination = this.panels[index]?.querySelector('[data-rail-mobile-all]');
      if (action && destination) {
        action.href = destination.href;
        action.setAttribute('aria-label', 'View all ' + this.tabs[index].textContent.trim() + ' cases');
      }
    }
    async followUseCaseLink(event) {
      const link = event.composedPath().find(node => node instanceof Element && node.matches('.ev-use-case-links a'));
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
      const destination = new URL(link.href, location.href);
      if (destination.origin !== location.origin || destination.pathname !== location.pathname || destination.search !== location.search || !destination.hash) return;
      const target = document.getElementById(decodeURIComponent(destination.hash.slice(1)));
      if (!target) return;
      const drawer = link.closest('navigation-drawer');
      const disclosure = link.closest('details');
      if (!drawer && !disclosure) return;
      event.preventDefault();
      // Let Impact release its focus trap and scroll lock before following the fragment.
      if (drawer && typeof drawer.hide === 'function') await drawer.hide();
      if (disclosure) disclosure.open = false;
      location.hash = destination.hash;
      target.scrollIntoView({block: 'start'});
      const heading = target.querySelector('h2') || target;
      if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
      heading.focus({preventScroll: true});
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}

if (!customElements.get('evolved-pill-nav')) {
  customElements.define('evolved-pill-nav', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.track = this.querySelector('.ev-pill-nav__track');
      this.buttons = [...this.querySelectorAll('[data-direction]')];
      if (!this.track) return;
      const update = () => {
        const overflow = this.track.scrollWidth > this.track.clientWidth + 2;
        this.toggleAttribute('data-overflow', overflow);
        this.buttons.forEach(button => {
          button.hidden = !overflow;
          button.disabled = Number(button.dataset.direction) < 0 ? this.track.scrollLeft < 2 : this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
        });
      };
      this.buttons.forEach(button => button.addEventListener('click', () => {
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.track.scrollBy({left: Number(button.dataset.direction) * this.track.clientWidth * .8, behavior});
      }, {signal: this.controller.signal}));
      this.track.addEventListener('scroll', update, {passive: true, signal: this.controller.signal});
      this.resizeObserver = new ResizeObserver(update);
      this.resizeObserver.observe(this.track);
      this.setAttribute('data-ready', '');
      update();
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; this.resizeObserver?.disconnect(); }
  });
}
